import { MAPS_KEY } from "./config";
import logger from "./logger";

export const getGeographicAreaFromCoordinates = async (latitude, longitude) => {
    try {
      const apiKey = MAPS_KEY;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
      );
      const data = await response.json();
  
      if (data.status === 'OK') {
        const addressComponents = data.results[0].address_components;
  
        // Check for various levels of geographic information
        const areaTypes = [
          // { type: 'postal_town', name: 'Town' },
          { type: 'locality', name: 'City' },
          { type: 'administrative_area_level_2', name: 'County' },
          { type: 'administrative_area_level_1', name: 'State/Region' },
          { type: 'country', name: 'Country' },
        ];
  
        for (const area of areaTypes) {
          const component = addressComponents.find((c) => c.types.includes(area.type));
          if (component) {
            return component.long_name;
          }
        }
  
        return 'Geographic area not found';
      } else {
        logger.error('Error fetching geographic area:', data.status);
        return 'Error fetching geographic area';
      }
    } catch (error) {
      logger.error('Error:', error);
      return 'Error fetching geographic area';
    }
  };